/*
 * Quantity selector block — quantity breaks behaviour
 * ===================================================
 * Moved out of blocks/product-quantity-selector-block.liquid so the block's
 * Liquid stays small and this file is cached by the browser. Two routines:
 *
 *  1. Refined pills / Coverage cards ("look"): fills in % saved, price per
 *     unit, money saved, free-gift value and shrinks card text to fit.
 *     Runs for a block root that carries data-qb-look and a config element.
 *
 *  2. Savings bar / per-tier countdown ("enh"): keeps the bar's split and
 *     labels in sync with the prices the theme paints, and handles what
 *     happens to a tier when its timer runs out.
 *     Runs for a block root that contains a bar or a timer.
 *
 * Each root is set up once (data-qb-js). The script also re-scans when the
 * theme editor reloads a section, and exposes window.QuantityBreaks.init().
 */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /* shared                                                              */
  /* ------------------------------------------------------------------ */

  /* Reads a rendered money string and learns its formatting at the same
     time, so amounts written back match the shop's currency, separators and
     decimal settings without duplicating the theme's formatter. */
  function parseMoneyFull(str, trimAffixes) {
    if (!str) return null;
    var text = trimAffixes ? String(str).trim() : String(str);
    var m = text.match(/\d[\d.,  \s']*\d|\d/);
    if (!m) return null;
    var raw = m[0].replace(/[  \s']/g, '');
    var last = Math.max(raw.lastIndexOf('.'), raw.lastIndexOf(','));
    var dec = '', grp = '', decimals = 0;
    if (last > -1 && /^\d{2}$/.test(raw.slice(last + 1))) {
      dec = raw.charAt(last); decimals = 2; grp = dec === '.' ? ',' : '.';
    }
    var value = parseFloat(dec ? raw.split(grp).join('').replace(dec, '.') : raw.replace(/[.,]/g, ''));
    if (isNaN(value)) return null;
    var prefix, suffix;
    if (trimAffixes) {
      prefix = text.slice(0, m.index).replace(/^.*?([^\d\s]*\s?)$/, '$1');
      suffix = (text.slice(m.index + m[0].length).match(/^\s?[^\d\s\/]{1,4}/) || [''])[0];
    } else {
      prefix = text.slice(0, m.index);
      suffix = text.slice(m.index + m[0].length);
    }
    return { value: value, prefix: prefix, suffix: suffix, dec: dec, grp: grp, decimals: decimals };
  }

  function formatLike(sample, value) {
    if (!sample) return '';
    var dec = sample.dec || '.', grp = sample.grp || (dec === '.' ? ',' : '.');
    var parts = Math.abs(value).toFixed(sample.decimals).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, grp);
    return sample.prefix + (sample.decimals ? whole + dec + parts[1] : whole) + sample.suffix;
  }

  function fill(tpl, map) {
    var out = tpl || '';
    for (var k in map) out = out.split('[' + k + ']').join(map[k]);
    return out;
  }

  function setText(el, txt) { if (el.textContent !== txt) el.textContent = txt; }

  /* ------------------------------------------------------------------ */
  /* 1. Refined pills / Coverage cards                                   */
  /* ------------------------------------------------------------------ */
  function initLook(root, blockId) {
    var breaks = root.querySelector('quantity-breaks');
    var cfgEl = document.querySelector('[data-qbx-config="' + blockId + '"]');
    if (!breaks || !cfgEl) return;
    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var look = root.getAttribute('data-qb-look');
    var mode = root.getAttribute('data-price-display-mode') || 'per_unit';
    var writing = false, queued = false, sample = null;

    function parseMoney(str) { return parseMoneyFull(str, true); }
    function fmt(v) { return formatLike(sample, v); }

    function tiers() {
      return Array.prototype.filter.call(breaks.querySelectorAll('[data-break-quantity]'), function (el) {
        var up = el.parentElement && el.parentElement.closest('[data-break-quantity]');
        return !up || !breaks.contains(up);
      });
    }

    /* Free gift value per quantity, read from a Free gift bundle block in the
       same section (tiles carry their unlock quantity and value in cents). */
    function giftValueFor(q) {
      if (!cfg.showGift) return 0;
      var scope = root.closest('[id^="shopify-section-"]') || document;
      var tiles = scope.querySelectorAll('[data-qkit] [data-qkit-tile]');
      var sum = 0;
      for (var i = 0; i < tiles.length; i++) {
        var host = tiles[i].closest('[data-qkit]');
        var tier = parseInt(tiles[i].getAttribute('data-qkit-tier'), 10) || parseInt(host.getAttribute('data-qkit-unlock'), 10) || 1;
        if (tier <= q) sum += (parseInt(tiles[i].getAttribute('data-qkit-cents'), 10) || 0) / 100;
      }
      return sum;
    }

    function baseRun() {
      queued = false;
      writing = true;
      if (!sample) {
        var s = document.querySelector('[data-qbx-sample="' + blockId + '"]');
        sample = parseMoney(s && s.textContent);
      }
      tiers().forEach(function (tier) {
        var btn = tier.classList.contains('quantity-break-button') ? tier : tier.querySelector('.quantity-break-button');
        if (!btn) return;
        var q = parseInt(tier.getAttribute('data-break-quantity'), 10) || 1;

        var gift = giftValueFor(q);
        var giftEl = btn.querySelector('[data-qbx-gift]');
        if (giftEl && sample) {
          if (gift > 0) {
            setText(giftEl, fill(cfg.gift, { value: fmt(gift) }));
            giftEl.removeAttribute('data-empty');
          } else {
            giftEl.setAttribute('data-empty', '');
          }
        }

        /* The tier's prices are written by the theme's own script, after any
           rounding; until they are there the server-rendered figures stand. */
        var priceLine = btn.querySelector('.qb-price-line:not(.qb-price-line--compare)') || btn.querySelector('[data-break-price]');
        var compareLine = btn.querySelector('.qb-price-line--compare') || btn.querySelector('[data-break-compare-price]');
        var p = parseMoney(priceLine && priceLine.textContent);
        if (!p || !sample) return;
        var c = parseMoney(compareLine && compareLine.textContent);
        var total = mode === 'total' ? p.value : p.value * q;
        var unitEl = btn.querySelector('[data-qbx-unit]');
        if (unitEl) setText(unitEl, (unitEl.classList.contains('qbx-unit--solo') || look === 'cards' ? '' : ' · ') + fill(cfg.unit, { price: fmt(total / q) }));
        /* With "Show compare at price" off there is no old price on the page to
           read, so the server-rendered saving and % tag are left as they are. */
        if (!c) return;
        var compareTotal = c ? (mode === 'total' ? c.value : c.value * q) : total;
        var saved = Math.max(0, compareTotal - total);
        var pct = compareTotal > 0 ? Math.round(saved / compareTotal * 100) : 0;

        var tag = btn.querySelector('[data-qbx-tag]');
        if (tag) {
          setText(tag, fill(cfg.tag, { percent: pct + '%', amount: fmt(saved) }));
          tag.hidden = pct <= 0;
        }
        var unit = btn.querySelector('[data-qbx-unit]');
        if (unit) setText(unit, (unit.classList.contains('qbx-unit--solo') || look === 'cards' ? '' : ' · ') + fill(cfg.unit, { price: fmt(total / q) }));
        var savedEl = btn.querySelector('[data-qbx-saved]');
        if (savedEl) {
          setText(savedEl, fill(cfg.saved, { amount: fmt(saved), percent: pct + '%' }));
          savedEl.hidden = saved <= 0;
        }
      });
      observer.takeRecords();
      writing = false;
    }

    function run() { baseRun(); scheduleFit(); }

    function schedule() {
      if (writing || queued) return;
      queued = true;
      window.requestAnimationFrame(run);
    }

    var observer = new MutationObserver(function (records) {
      if (writing) return;
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        var el = t.nodeType === 1 ? t : t.parentElement;
        if (el && el.closest && el.closest('.qbx-chips, .qbx-segs, .qbx-tag, .qbx-unit, .qbx-saved, .qb-then')) continue;
        schedule();
        return;
      }
    });
    observer.observe(breaks, { childList: true, characterData: true, subtree: true });

    /* Shrinks each row of text (price, old price, saving, chip) in steps until
       its longest value fits inside its card, using one size for all cards. */
    var ROWS = [
      { v: '--qbx-fs-price', sel: '.qb-price-line:not(.qb-price-line--compare)', max: 1.125, min: 0.72 },
      { v: '--qbx-fs-compare', sel: '.qb-price-line--compare', max: 0.85, min: 0.62 },
      { v: '--qbx-fs-saved', sel: '.qbx-saved', max: 0.8, min: 0.6 },
      { v: '--qbx-fs-chip', sel: '.qbx-chip:not(.qbx-chip--gift)', max: 0.7, min: 0.55 }
    ];
    var fitting = false;
    function fit() {
      if (look !== 'cards' || fitting) return;
      fitting = true;
      var buttons = Array.prototype.map.call(tiers(), function (t) {
        return t.classList.contains('quantity-break-button') ? t : t.querySelector('.quantity-break-button');
      }).filter(Boolean);
      ROWS.forEach(function (row) {
        var size = row.max;
        root.style.setProperty(row.v, size + 'rem');
        for (var guard = 0; guard < 30 && size > row.min; guard++) {
          var over = buttons.some(function (btn) {
            var el = btn.querySelector(row.sel);
            if (!el || !el.offsetParent) return false;
            var cs = getComputedStyle(btn);
            var room = btn.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
            return el.scrollWidth > room + 0.5;
          });
          if (!over) break;
          size = Math.max(row.min, Math.round((size - 0.025) * 1000) / 1000);
          root.style.setProperty(row.v, size + 'rem');
        }
      });
      fitting = false;
    }
    var fitQueued = false;
    function scheduleFit() {
      if (fitQueued) return;
      fitQueued = true;
      window.requestAnimationFrame(function () { fitQueued = false; fit(); });
    }
    if (look === 'cards') {
      if (typeof ResizeObserver !== 'undefined') new ResizeObserver(scheduleFit).observe(breaks);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleFit);
    }

    run();
    document.addEventListener('qkit:ready', function () { run(); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
    else schedule();
    window.addEventListener('load', schedule, { once: true });
    window.setTimeout(schedule, 1200);
  }

  /* ------------------------------------------------------------------ */
  /* 2. Savings bar / per-tier countdown                                 */
  /* ------------------------------------------------------------------ */
  function initEnh(root) {
    var breaks = root.querySelector('quantity-breaks');
    if (!breaks) return;

    var observer = null;
    var writing = false;
    var expiredTiers = {};

    var displayMode = root.getAttribute('data-price-display-mode') || 'per_unit';

    function parseMoney(str) { return parseMoneyFull(str, false); }

    function items() {
      return breaks.querySelectorAll('[data-break-quantity]');
    }

    function release() {
      if (observer) observer.takeRecords();
      writing = false;
    }

    function tierIndex(item) {
      var marked = item.querySelector('[data-qb-index]');
      return marked ? marked.getAttribute('data-qb-index') : null;
    }

    function updateTier(item) {
      var idx = tierIndex(item);
      if (idx && expiredTiers[idx]) {
        expireTier(item);
        return;
      }

      var priceEl = item.querySelector('[data-break-price]');
      if (!priceEl) return;

      var compareEl = item.querySelector('[data-break-compare-price]');
      var pay = parseMoney(priceEl.textContent);
      var full = compareEl ? parseMoney(compareEl.textContent) : null;
      var discounted = !!(pay && full && full.value > pay.value);

      var qty = parseInt(item.getAttribute('data-break-quantity') || '1', 10) || 1;
      var payTotal = displayMode === 'per_unit' ? pay ? pay.value * qty : 0 : pay ? pay.value : 0;
      var fullTotal = displayMode === 'per_unit' ? full ? full.value * qty : 0 : full ? full.value : 0;

      /* the regular price quoted inside this tier's timer */
      var thenOut = item.querySelector('[data-qb-then-price]');
      if (thenOut && full) {
        thenOut.textContent = formatLike(full, full.value);
      }

      var bar = item.querySelector('[data-qb-bar]');
      if (!bar) return;

      if (!discounted) {
        bar.classList.add('qb-bar--flat');
        return;
      }
      bar.classList.remove('qb-bar--flat');

      var savedTotal = fullTotal - payTotal;
      var paidPct = Math.max(0, Math.min(100, (payTotal / fullTotal) * 100));
      bar.setAttribute('data-qb-paid-pct', paidPct.toFixed(2));

      var perUnit = bar.getAttribute('data-qb-mode') === 'per_unit';
      var payOut = bar.querySelector('[data-qb-bar-pay]');
      var saveOut = bar.querySelector('[data-qb-bar-save]');

      if (payOut) payOut.textContent = formatLike(pay, perUnit ? payTotal / qty : payTotal);
      if (saveOut) saveOut.textContent = formatLike(full, perUnit ? savedTotal / qty : savedTotal);
    }

    /* The divide is pushed off its exact ratio rather than shrinking a label,
       so every tier renders its wording at the same size. Each tier reserves
       only what its own label needs, so no bar moves further than it has to. */
    function sideRoom(seg) {
      var cs = window.getComputedStyle(seg);
      return (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0) + 4;
    }

    function layoutBars() {
      var bars = breaks.querySelectorAll('[data-qb-bar]');
      if (!bars.length) return;

      var rows = [];
      Array.prototype.forEach.call(bars, function (bar) {
        var track = bar.querySelector('.qb-bar__track');
        var paid = bar.querySelector('[data-qb-bar-paid]');
        var saved = bar.querySelector('[data-qb-bar-saved]');
        if (!track || !paid || !saved) return;

        paid.classList.remove('is-compact', 'is-bare');
        saved.classList.remove('is-compact', 'is-bare');

        var paidLabel = paid.querySelector('.qb-bar__label');
        var savedLabel = saved.querySelector('.qb-bar__label');

        rows.push({
          track: track,
          paid: paid,
          saved: saved,
          needPaid: (paidLabel ? paidLabel.offsetWidth : 0) + sideRoom(paid),
          needSaved: (savedLabel ? savedLabel.offsetWidth : 0) + sideRoom(saved),
          natural: parseFloat(bar.getAttribute('data-qb-paid-pct') || '100')
        });
      });
      if (!rows.length) return;

      rows.forEach(function (row) {
        var width = row.track.clientWidth;
        if (!width) return;

        if (row.needPaid + row.needSaved <= width) {
          var target = (row.natural / 100) * width;
          target = Math.min(Math.max(target, row.needPaid), width - row.needSaved);
          var pct = (target / width) * 100;
          row.paid.style.width = pct.toFixed(2) + '%';
          row.saved.style.width = (100 - pct).toFixed(2) + '%';
          return;
        }

        /* genuinely not enough room at any split: keep the true ratio and
           shorten the wording instead */
        row.paid.style.width = row.natural.toFixed(2) + '%';
        row.saved.style.width = (100 - row.natural).toFixed(2) + '%';
        shorten(row.paid);
        shorten(row.saved);
      });
    }

    function shorten(seg) {
      var label = seg.querySelector('.qb-bar__label');
      if (!label) return;
      var room = seg.clientWidth - sideRoom(seg) + 8;
      if (label.offsetWidth <= room) return;
      seg.classList.add('is-compact');
      if (label.offsetWidth <= room) return;
      seg.classList.add('is-bare');
    }

    function expireTier(item) {
      item.classList.add('is-expired');

      var priceEl = item.querySelector('[data-break-price]');
      var compareEl = item.querySelector('[data-break-compare-price]');
      if (priceEl && compareEl) {
        var full = parseMoney(compareEl.textContent);
        if (full) priceEl.textContent = formatLike(full, full.value);
      }

      var save = item.querySelector('[data-break-save]');
      if (save) save.style.display = 'none';

      Array.prototype.forEach.call(
        item.querySelectorAll('[class*="bg-theme-accent"][class*="text-theme-card"]'),
        function (badge) { badge.style.display = 'none'; }
      );
    }

    function sync() {
      if (writing) return;
      writing = true;
      Array.prototype.forEach.call(items(), updateTier);
      layoutBars();
      release();
    }

    observer = new MutationObserver(function (records) {
      if (writing || !records.length) return;

      var relevant = records.some(function (record) {
        var node = record.target;
        if (node.nodeType === 3) node = node.parentElement;
        return node && !node.closest('[data-qb-then]');
      });
      if (!relevant) return;

      sync();
    });
    observer.observe(breaks, { childList: true, subtree: true, characterData: true });

    if (typeof ResizeObserver !== 'undefined') {
      var scheduled = false;
      var sizes = new ResizeObserver(function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
          scheduled = false;
          layoutBars();
        });
      });
      Array.prototype.forEach.call(breaks.querySelectorAll('.qb-bar__track'), function (track) {
        sizes.observe(track);
      });
    }

    /* Each tier owns its own timer, so expiry is handled tier by tier. */
    function onTimerEnd(then) {
      var action = then.getAttribute('data-qb-on-expire') || 'none';
      if (action === 'none') return;

      then.classList.add('is-expired');
      var ended = then.querySelector('[data-qb-then-ended]');
      if (ended) ended.hidden = false;

      if (action !== 'revert') return;

      var item = then.closest('[data-break-quantity]');
      if (!item) return;

      var idx = then.getAttribute('data-qb-index');
      if (idx) expiredTiers[idx] = true;

      writing = true;
      expireTier(item);
      release();
    }

    /* The theme defines <countdown-timer> from a chunk that main.js loads on
       demand, so it is normally not defined yet when this runs and the listener
       below catches every ending. Should the element already be defined and a
       date-based timer already at zero, its end event has been and gone, so the
       same handling is applied directly. */
    var timerDefined = !!(window.customElements && window.customElements.get('countdown-timer'));
    function alreadyEnded(timer) {
      if (!timerDefined || timer.getAttribute('data-countdown-mode') !== 'date') return false;
      var parts = ['days', 'hours', 'minutes', 'seconds'];
      for (var i = 0; i < parts.length; i++) {
        var el = timer.querySelector('[data-countdown-' + parts[i] + ']');
        if (el && parseInt(el.textContent, 10) !== 0) return false;
      }
      var end = new Date(String(timer.getAttribute('data-end-date') || '').replace(' ', 'T'));
      return !isNaN(end.getTime()) && end.getTime() <= Date.now();
    }

    Array.prototype.forEach.call(breaks.querySelectorAll('[data-qb-then]'), function (then) {
      var timer = then.querySelector('[data-countdown-timer]');
      if (!timer) return;

      timer.addEventListener('countdown:end', function () { onTimerEnd(then); });
      if (alreadyEnded(timer)) onTimerEnd(then);
    });

    /* Driven through the Web Animations API rather than a CSS class. Replaying a
       class-based animation means removing it, forcing a synchronous layout so
       the removal registers, then re-adding it, which costs a reflow every
       second per tier. Calling animate() replays it outright. */
    var stillFrames = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!stillFrames) {
      Array.prototype.forEach.call(
        breaks.querySelectorAll('[data-qb-then][data-qb-tick] [data-countdown-seconds]'),
        function (secs) {
          var playing = null;

          new MutationObserver(function () {
            if (playing) playing.cancel();
            playing = secs.animate(
              [
                { transform: 'translateY(-0.14em)', opacity: 0.35, offset: 0 },
                { transform: 'translateY(0.02em)', opacity: 1, offset: 0.6 },
                { transform: 'translateY(0)', opacity: 1, offset: 1 }
              ],
              { duration: 220, easing: 'ease-out' }
            );
          }).observe(secs, { childList: true, characterData: true, subtree: true });
        }
      );
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync, { once: true });
    } else {
      sync();
    }
    setTimeout(sync, 300);
    setTimeout(sync, 1200);
  }

  /* ------------------------------------------------------------------ */
  /* bootstrap                                                           */
  /* ------------------------------------------------------------------ */
  function initRoot(root) {
    if (root.getAttribute('data-qb-js') === 'true') return;
    root.setAttribute('data-qb-js', 'true');
    var blockId = root.getAttribute('data-qb-root');
    if (root.hasAttribute('data-qb-look')) initLook(root, blockId);
    if (root.querySelector('[data-qb-bar], [data-qb-then]')) initEnh(root);
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-qb-root]');
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }

  window.QuantityBreaks = window.QuantityBreaks || { init: init };
  init();

  /* theme editor: a section is re-rendered and swapped in after a change */
  if (!window.__qbSectionLoadBound) {
    window.__qbSectionLoadBound = true;
    document.addEventListener('shopify:section:load', function (event) { init(event.target || document); });
  }
})();
